import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import {
  Button,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField
} from '@mui/material';

import './UpdateDenounceForm.scss';

function UpdateDenounceForm({ denounce, denounceStatus, onSubmit }) {
  const possibleDenounceStatus = getPossibleDenounceStatus();
  const {
    initialDescription,
    initialHasVisited,
    initialAgentFeedback,
    initialDenounceStatus
  } = getInitialValues(possibleDenounceStatus, denounce);
  const hasVisitedOptions = {
    YES: 'visited',
    NO: 'notVisited'
  };
  const [hasVisitedDenounce, setHasVisitedDenounce] = useState(initialHasVisited ? hasVisitedOptions.YES : hasVisitedOptions.NO);

  function getInitialValues(possibleDenounceStatus, denounce) {
    const initialDescription = denounce?.description;
    const initialHasVisited = !!denounce?.visited_at;
    const initialAgentFeedback = denounce?.agent_feedback;
    const initialDenounceStatus = possibleDenounceStatus?.find(item => item.id === denounce?.denounce_status_id);
    return {
      initialDescription,
      initialHasVisited,
      initialAgentFeedback,
      initialDenounceStatus
    }
  }

  function getPossibleDenounceStatus() {
    return denounceStatus || [];
  }

  function validate(values) {
    const errors = {};

    if (!values.agentFeedback) {
      errors.agentFeedback = 'Precisamos saber sua opinião sobre este foco/denúncia';
    }

    if (!values.denounceStatusId) {
      errors.denounceStatusId = 'Selecione o status da denúncia';
    }

    return errors;
  }

  const handleSubmit = (values, { setSubmitting }) => {
    values.hasVisited = hasVisitedDenounce === hasVisitedOptions.YES;
    values.denounceStatus = possibleDenounceStatus.find(item => item.label === values.denounceStatusId);

    onSubmit(values, { setSubmitting });
  };

  if (!initialDenounceStatus?.label) {
    return <></>;
  }

  return (
    <Formik
      initialValues={{
        description: initialDescription,
        hasVisited: hasVisitedDenounce ? hasVisitedOptions.YES : hasVisitedOptions.NO,
        agentFeedback: initialAgentFeedback,
        denounceStatusId: initialDenounceStatus.label
      }}
      validate={validate}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="form">
          <Field
            as={TextField}
            multiline
            maxRows={4}
            className="field"
            name="description"
            label="Descrição Inicial"
            variant="outlined"
            fullWidth
            disabled
          />
          <ErrorMessage name="description" component="div" />
          <Field
            name="hasVisited"
            variant="outlined"
            fullWidth
          >
            {({ field }) => (
              <div className="field radio-buttons">
                <FormLabel>Você visitou o local da denúncia?</FormLabel>
                <RadioGroup>
                  <FormControlLabel
                    value={hasVisitedOptions.YES}
                    control={
                      <Radio
                        type="radio"
                        checked={hasVisitedDenounce === hasVisitedOptions.YES}
                        onChange={() => setHasVisitedDenounce(hasVisitedOptions.YES)}
                      />}
                    label="Sim"
                    {...field}
                  />
                  <FormControlLabel
                    value={hasVisitedOptions.NO}
                    control={
                      <Radio
                        type="radio"
                        checked={hasVisitedDenounce === hasVisitedOptions.NO}
                        onChange={() => setHasVisitedDenounce(hasVisitedOptions.NO)}
                      />}
                    label="Não"
                    {...field}
                  />
                </RadioGroup>
              </div>
            )}
          </Field>
          <ErrorMessage name="hasVisited" component="div" />
          <Field
            as={TextField}
            multiline
            maxRows={6}
            className="field"
            name="agentFeedback"
            label="Suas observações sobre o caso"
            variant="outlined"
            fullWidth
          />
          <ErrorMessage name="agentFeedback" component="div" />
          <Field
            as={TextField}
            select
            defaultValue={initialDenounceStatus.label}
            className="field select"
            name="denounceStatusId"
            label="Status do foco"
            variant="outlined"
            fullWidth
          >
            {possibleDenounceStatus.map((option) => (
              <MenuItem key={option.key} value={option.label} className="menu-item">
                <div className="menu-item-text-wrapper">
                  <span className="text">{option.label}</span>
                </div>
              </MenuItem>
            ))}
          </Field>
          <ErrorMessage name="denounceStatusId" component="div" />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="button"
            disabled={isSubmitting}
            fullWidth
          >
            {isSubmitting ? 'Enviando ...' : 'Atualizar denúncia'}
          </Button>
        </Form>
      )}
    </Formik>
  );
}

export default UpdateDenounceForm;
